import { STUDENT_TYPES } from '../services/studentService';

export const getStudentTypeLabel = (studentType) => {
  if (studentType === STUDENT_TYPES.SECONDARY) return 'Secondary';
  if (studentType === STUDENT_TYPES.PROFESSIONAL) return 'Professional';
  return studentType || '—';
};

export const getProgramLabel = (student) => {
  if (!student) return '—';
  if (student.studentType === STUDENT_TYPES.PROFESSIONAL) {
    const courses = Array.isArray(student.courses)
      ? student.courses
      : student.course
        ? [student.course]
        : [];
    return courses.join(', ') || student.fieldOfStudy || '—';
  }
  return student.fieldOfStudy || '—';
};

export const getBatchLabel = (student) => {
  const batch = student?.batch;
  if (!batch) return '—';
  if (typeof batch === 'object') return batch.name || '—';
  return '—';
};

export const getStudentBatchId = (student) => {
  const batch = student?.batch;
  if (!batch) return '';
  if (typeof batch === 'object' && batch._id) return String(batch._id);
  return String(batch);
};

export const formatBatchDates = (batch) => {
  if (!batch?.startDate) return '';
  const start = new Date(batch.startDate).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  const end = batch.expectedEndDate
    ? new Date(batch.expectedEndDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
    : '';
  return end ? `${start} – ${end}` : start;
};
